import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { store } from 'react-notifications-component';
import { useGlobalContext } from '../../../context/GlobalContext';
import arrow from '../../../../assets/images/icons/arrow.svg';
import gift from '../../../../assets/images/icons/gift.svg';
import fist from '../../../../assets/images/icons/fist.svg';
import promo from '../../../../assets/images/icons/promo.svg';
import styles from './EditOffer.module.scss';
import { MESSAGE_OFFERS } from '../../../../actions/types';
import { getOfferAction, postProductAction, putProductAction } from '../../../../actions/offersActions';
import Input from '../../../Partials/form_fields/Input';
import InputFile from '../../../Partials/form_fields/InputFile/InputFile';
import { API_URL } from '../../../../actions';
import Textarea from '../../../Partials/form_fields/Textarea';
import { getProvidersListAction } from '../../../../actions/providersActions';
import StyledSelect from '../../../Partials/form_fields/StyledSelect/StyledSelect';
import { deliveryOptions, offersStatusOptions } from '../../../../constants/constants';

const required = "Ce champ est requis";

export default function EditOffer({ setActivePage  }) {
  const [ context , dispatch ] = useGlobalContext();
  const { id } = useParams();

  const { offer, message }  = context.offers;
  const providersOptions = context.providers?.providersList?.map((p) => ({ value: p._id, label: p.name})) || [];

  const containerRef = useRef();
  const [ imgError , setImgError ] = useState(false);
  const [ adventage, setAdventage] = useState({ type: null , value: null });
  const [form, setForm ] = useState({

  });
  const [errors, setErrors] = useState({})

  const getData = useCallback(() => {
    setActivePage("offers");
    getProvidersListAction(dispatch);
    if (id) {
      getOfferAction(dispatch ,id);
    }
  }, [dispatch, setActivePage, id]);


  function handleChangeForm(obj) {
    setForm({...form, ...obj});
  } 

  function submit(obj = {}) {
    const errorsData = {}  
    if (!form.ref) {
      errorsData.ref = required;
    }
    // if (!form.brand) {
    //   errorsData.brand = required;
    // }
    if (!form.gencod) {
      errorsData.gencod = required;
    }
    if (!form.description) {
      errorsData.description = required;
    }
    if (!form.type) {
      errorsData.type = required;
    }
    // if (!form.department) {
    //  errorsData.department = required;
    // }
    if (!form.packing) {
      errorsData.packing = required;
    }
    if (!form.company) {
      errorsData.company = required;
    }
    if (!form.price) {
      errorsData.price = required;
    }
    if (!form.delivery) {
      errorsData.delivery = required;
    }
    if (!form.deliveryDate) {
      errorsData.deliveryDate = required;
    }
    if (!form.discountGalec) {
      errorsData.discountGalec = required;
    }
    if (!adventage.value) {
      errorsData.adventages = required;
    }
    if (!form.tva) {
      errorsData.tva = required;
    }
    if (!form.pricePABrut) {
      errorsData.pricePABrut = required;
    }
    setErrors(errorsData);
    if (Object.keys(errorsData).length > 0) {
      return null;
    }
    const data = {...form, ...obj };
    data.discount = null;
    data.punch = null;
    data.gift = null;
    if (adventage.type && adventage.value) {
      data[adventage.type] = adventage.value;
    }
    if (form?.company?._id) {
      data.company = form?.company?._id;
    }
    if (form?.image?._id) {
      data.image = form?.image?._id;
    }
    if(!offer?._id) {
      return postProductAction(dispatch, {...data });
    }
    return putProductAction(dispatch, offer?._id,  data );
  }

  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    if (offer?._id) {
      if (offer.discount || offer.discount === 0) {
        setAdventage({ type: "discount", value: parseFloat(offer.discount) });
      }
      if (offer.punch) {
        setAdventage({ type: "punch", value: offer.punch });
      }
      if (offer.gift) {
        setAdventage({ type: "gift", value: offer.gift });
      }
      setForm(offer);
    }
  },[offer]);

  useEffect(() => {
    if (message) {
      store.addNotification({
        message,
        type: "success",
        insert: "top",
        container: "bottom-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true
        }
      });
      dispatch({
        type : MESSAGE_OFFERS,
        payload : null,
      });
    }
  },[dispatch, message]);

  return (
    <div ref={containerRef} className={styles.container}>
      <div className={styles.back}>
        {offer?._id ?
          <Link to={`/offer-view/${offer?._id }`}>
           <img src={arrow} alt="back"/> <p>Retour</p>
          </Link>
        :
          <Link to={`/offers`}>
           <img src={arrow} alt="back"/> <p>Retour</p>
          </Link>
        }
      </div>
      <header className={styles.header}>
        <h1>{offer?.ref || 'Nouveau produit' }</h1>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.submit}
            onClick={() => submit()}
          >
            Enregistrer
          </button>
        </div>
      </header>

      <main className={styles.content}>
        <div className={styles['col-2']}>
          <div className={styles.block}>
            <h2>Info</h2>
            <div className={styles.row}>
              <div className={styles['col-1']}>
                <Input
                  label="Nom du produit"
                  value={form?.ref || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.ref}
                  loading={false}
                  onChange={(val) => handleChangeForm({ ref : val})}
                />
              </div>
            </div>
            <div className={styles.row}>
            <div className={styles['col-2']}>
                <StyledSelect
                  className="input secondary"
                  label="Status de l'offre"
                  value={offersStatusOptions?.find((d) => d.value === form?.status)}
                  options={offersStatusOptions}
                  placeholder="Sélectionner"
                  onChange={(opt) => handleChangeForm({ status: opt.value })}
                />
              </div>
              <div className={styles['col-2']}>
                <Input
                  label="Gencod"
                  value={form?.gencod || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.gencod}
                  loading={false}
                  onChange={(val) => handleChangeForm({ gencod : val })}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <StyledSelect
                  className="input secondary"
                  label="Fournisseur"
                  value={providersOptions?.find((d) => d.value === form?.company?._id || d.value === form?.company)}
                  options={providersOptions}
                  error={errors?.company}
                  placeholder="Sélectionner"
                  onChange={(opt) => handleChangeForm({ company: opt.value })}
                />
              </div>
              <div className={styles['col-2']}>
                <Input
                  label="Marque"
                  value={form?.brand || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.brand}
                  loading={false}
                  onChange={(val) => handleChangeForm({ brand : val })}
                />
              </div>
            </div>
            {!offer?.image?.path && offer?.gencod && !imgError &&
              <div className={styles.row}>
                <div className={styles['col-1']}>
                  <div className={styles.image}>
                    {!imgError && <img
                      src={`${API_URL}/static/products/${offer.gencod}.jpg`}
                      onError={() => setImgError(true)}
                      alt="product"/>}
                  </div>
                </div>
              </div>
            }
            {<div className={styles.row}>
              <div className={styles['col-1']} style={{ marginBottom: 20 }}>
                <InputFile
                  file={form?.image || ''}
                  id="cover"
                  label="Télécharger l'image du produit"
                  postFile={!offer?._id ? (image) => submit({ ...form, image }) : null}
                  onChange={(val) => putProductAction(dispatch, offer?._id, { image: val })}
              />
              </div>
            </div>
            }
            <div className={styles.row}>
              <div className={styles['col-1']}>
                <Input
                  label="Designation du produit"
                  value={form?.description || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.description}
                  loading={false}
                  onChange={(val) => handleChangeForm({ description : val})}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <Input
                  label="Typo"
                  value={form?.type || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.type}
                  loading={false}
                  onChange={(val) => handleChangeForm({ type : val})}
                />
              </div>
              <div className={styles['col-2']}>
                <Input
                  label="Colisage"
                  value={form?.packing || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.packing}
                  loading={false}
                  onChange={(val) => handleChangeForm({ packing : val })}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-1']}>
                <Textarea
                  label="Détails box"
                  value={form?.box || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.box}
                  loading={false}
                  onChange={(val) => handleChangeForm({ box : val })}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <Input
                  label="Code article"
                  value={form?.code || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.code}
                  loading={false}
                  onChange={(val) => handleChangeForm({ code : val })}
                />
              </div>
              <div className={styles['col-2']}>
                <Input
                  label="Numéro de dossier"
                  value={form?.fileNumber || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.fileNumber}
                  loading={false}
                  onChange={(val) => handleChangeForm({ fileNumber : val })}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <Input
                  label="Codelec"
                  value={form?.codelec || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.codelec}
                  loading={false}
                  onChange={(val) => handleChangeForm({ codelec : val })}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles['col-2']}>
          <div className={styles.block}>
            <h2>Livraison</h2>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <StyledSelect
                  className="input secondary"
                  label="Livraison"
                  value={deliveryOptions?.find((d) => d.value === form?.delivery?._id || d.value === form?.delivery)}
                  options={deliveryOptions}
                  placeholder="Sélectionner"
                  error={errors?.delivery}
                  onChange={(opt) => handleChangeForm({ delivery: opt.value })}
                />
              </div>
              <div className={styles['col-2']}>
                <Input
                  label="Semaine de livraison"
                  value={form?.deliveryDate || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.deliveryDate}
                  loading={false}
                  onChange={(val) => handleChangeForm({ deliveryDate : val })}
                />
              </div>

            </div>
          </div>
          <div className={styles.block}>
            <h2>Tarif</h2>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <Input
                  label="Prix net salon"
                  value={form?.price}
                  placeholder={""}
                  type={"number"}
                  className="input secondary"
                  loading={false}
                  step="0.01"
                  error={errors?.price}
                  onChange={(val) => handleChangeForm({ price: parseFloat(val) })}
                />
              </div>
              <div className={styles['col-2']}>
                <Input
                  label="PA permanent (si permanent)"
                  value={form?.pricePA}
                  placeholder={""}
                  type={"number"}
                  className="input secondary"
                  step="0.01"
                  error={errors?.pricePA}
                  loading={false}
                  onChange={(val) => handleChangeForm({ pricePA : parseFloat(val)  })}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <Input
                  label="PA BRUT"
                  value={form?.pricePABrut}
                  placeholder={""}
                  type={"number"}
                  className="input secondary"
                  step="0.01"
                  error={errors?.pricePABrut}
                  loading={false}
                  onChange={(val) => handleChangeForm({ pricePABrut : parseFloat(val)  })}
                />
              </div>
              <div className={styles['col-2']}>
                <Input
                  label="TVA"
                  value={form?.tva}
                  placeholder={""}
                  type={"number"}
                  className="input secondary"
                  step="0.01"
                  error={errors?.tva}
                  loading={false}
                  onChange={(val) => handleChangeForm({ tva : parseFloat(val)  })}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <Input
                  label="DEEE"
                  value={form?.deee}
                  placeholder={""}
                  type={"number"}
                  className="input secondary"
                  loading={false}
                  step="0.01"
                  error={errors?.deee}
                  onChange={(val) => handleChangeForm({ deee: parseFloat(val) })}
                />
              </div>
              <div className={styles['col-2']}>
                <Input
                  label="Autres taxes"
                  value={form?.tax}
                  placeholder={""}
                  type={"number"}
                  className="input secondary"
                  step="0.01"
                  error={errors?.tax}
                  loading={false}
                  onChange={(val) => handleChangeForm({ tax : parseFloat(val)  })}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <Input
                  label="Détail remises permanent"
                  value={form?.discountGalec || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.discountGalec}
                  loading={false}
                  onChange={(val) => handleChangeForm({ discountGalec : val })}
                />
              </div>
              <div className={styles['col-2']}>
                <Input
                  label="Remise Promo"
                  value={form?.discountPromo || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.discountPromo}
                  loading={false}
                  onChange={(val) => handleChangeForm({ discountPromo : val })}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles['col-2']}>
                <Input
                  label="Département de l'accord"
                  value={form?.department || ''}
                  placeholder={""}
                  type={"text"}
                  className="input secondary"
                  error={errors?.department}
                  loading={false}
                  onChange={(val) => handleChangeForm({ department : val })}
                />
              </div>
            </div>
            <div className={styles.adventages}>
              <label className='bold'>Avantage</label>
              <div className={styles.list}>
                <div className={styles.item}
                  onClick={() => setAdventage(adventage.type !== "gift" ? { type: "gift" , value: "" } : { type: null , value: null })}
                > 
                  <div className={`${styles.icon} ${adventage.type === "gift" &&  styles.active}`}> 
                    <img src={gift} alt="gift" />
                  </div>
                  <p>Cadeau</p>
                </div>
                <div className={styles.item}
                  onClick={() => setAdventage(adventage.type !== "punch" ? { type: "punch" , value: "" } : { type: null , value: null })}
                > 
                  <div className={`${styles.icon} ${adventage.type === "punch" && styles.active}`}> 
                    <img src={fist} alt="gift" />
                  </div>
                  <p>Coup de poing</p>
                </div>
                <div className={styles.item}
                  onClick={() => setAdventage(adventage.type !== "discount" ? { type: "discount" , value: "" } : { type: null , value: null })}
                > 
                  <div className={`${styles.icon} ${adventage.type === "discount"  && styles.active}`}> 
                    <img src={promo} alt="gift" />
                  </div>
                  <p>% remise</p>
                </div>
              </div>
              {errors.adventages && <p className={styles.error}>{errors.adventages}</p>}
            </div>
              <div className={styles.row}>
                {adventage.type === "gift" &&
                  <div className={styles['col-2']}>
                    <Input
                      label="Cadeau"
                      value={adventage.value}
                      placeholder={""}
                      type={"text"}
                      className="input secondary"
                      loading={false}
                      onChange={(val) => setAdventage({ type: "gift", value: val })}
                    />
                  </div>
                }
                {adventage.type === "punch" &&
                  <div className={styles['col-2']}>
                    <Input
                      label="Coup de poing"
                      value={adventage.value}
                      placeholder={""}
                      type={"text"}
                      className="input secondary"
                      loading={false}
                      onChange={(val) => setAdventage({ type: "punch", value: val })}
                    />
                  </div>
                }
                {adventage.type === "discount" &&
                  <div className={styles['col-2']}>
                    <Input
                      label="Promotion"
                      value={(adventage.value || adventage.value === 0) ? parseFloat(adventage.value) : ''}
                      placeholder={""}
                      type={"number"}
                      className="input secondary"
                      loading={false}
                      step="0.01"
                      onChange={(val) => setAdventage({ type: "discount", value: val > 0 ? parseFloat(val): val })}
                    />
                  </div>
                }
              </div>
          </div>
        </div>
      </main>

    </div>
  )
}
